import { Icon, Radio } from '@petsmart-ui/sparky';

import type { SortProductIconOptionIconProps } from '@/components/SortProduct/types';

export default function SortProductOptionIcon({ type, value, currentRefinement }: SortProductIconOptionIconProps) {
    if (type === 'radio') {
        const active = value === currentRefinement;
        return (
            <Radio
                name="sort-product"
                checked={active}
                onChange={() => null}
                data-testid={`filter-choice-type-radio-${active ? 'checked' : 'unchecked'}`}
            />
        );
    }

    if (type === 'check' && value === currentRefinement) {
        return (
            <Icon
                size="md"
                name="check"
                data-testid="sort-product-check-selected"
                className="sort-product__item--checked"
            />
        );
    }

    return <span className="sort-product__item--not-choice" />;
}
